import variableColors from "@/base/global/variables/figma.colors.json";
// import variableTypography from '@/base/global/variables/figma.typography.json';
// import variableEffects from '@/base/global/variables/figma.effects.json';

export const imageThemeToken: any = {
  colorBgContainerDisabled: variableColors["ColorFigmaNeutralWhiteWhite100"],
};
